exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-dialog{background-color:#fff;padding:40px;position:relative;min-width:200px}.wrap-loading{text-align:center;padding-bottom:20px}", ""]);

// exports
